import styled from 'styled-components';
import LogoutHeaderSVG from '../../assets/header/ic-logout.svg';

const LogoutHeaderIcon = styled(LogoutHeaderSVG as React.SFC<React.SVGProps<SVGSVGElement>>,)`
  width: ${props => props.width || '1.8rem'};
  height: ${props => props.height || '1.8rem'};
  fill: ${props => props.color};
  margin: ${props => props.margin};
`;

export default LogoutHeaderIcon;
